module.exports = __webpack_public_path__ + "img/logoduke.f52367a9.svg";